import {
  BLUESKY_PHOTO_SIZE_LIMIT,
  BLUESKY_VIDEO_SIZE_LIMIT,
  BRAND_BLUESKY,
  BRAND_TIKTOK,
  TIKTOK_PHOTO_MAX_WIDTH_OR_HEIGHT,
  TIKTOK_PHOTO_SIZE_LIMIT
} from 'shared/constants'
import { MediaItemState } from '../state'

// Files merged from the media context may carry the raw upload, whose size is authoritative.
export type FileValidationItem = MediaItemState & { file?: File }

// Validators return message keys so the same rules gate submission and render the network's error list.
type NetworkFileValidator = (files: FileValidationItem[]) => string[]

const isOverSizeLimit = (file: FileValidationItem, limit: number) => {
  const size = file.file?.size || file.size
  return Boolean(size && size > limit)
}

const getBlueskyFileErrors: NetworkFileValidator = files => {
  const errors: string[] = []
  if (files.some(file => !file.isVideo && isOverSizeLimit(file, BLUESKY_PHOTO_SIZE_LIMIT))) {
    errors.push('composer.errors.bluesky.max-photo-size')
  }
  if (files.some(file => file.isVideo && isOverSizeLimit(file, BLUESKY_VIDEO_SIZE_LIMIT))) {
    errors.push('composer.errors.bluesky.max-video-size')
  }
  return errors
}

const getTiktokFileErrors: NetworkFileValidator = files => {
  const errors: string[] = []
  const photos = files.filter(file => !file.isVideo)
  if (photos.some(file => file.size && file.size > TIKTOK_PHOTO_SIZE_LIMIT)) {
    errors.push('composer.errors.tiktok.photo-filesize')
  }
  if (photos.some(file => file.width && file.height
    && (file.width > TIKTOK_PHOTO_MAX_WIDTH_OR_HEIGHT || file.height > TIKTOK_PHOTO_MAX_WIDTH_OR_HEIGHT)
  )) {
    errors.push('composer.errors.tiktok.photo-dimensions')
  }
  return errors
}

export const NETWORK_FILE_VALIDATORS: Record<string, NetworkFileValidator> = {
  [BRAND_BLUESKY]: getBlueskyFileErrors,
  [BRAND_TIKTOK]: getTiktokFileErrors
}

export function getNetworkFileErrors(network: string, files: FileValidationItem[]): string[] {
  return NETWORK_FILE_VALIDATORS[network]?.(files) ?? []
}

export function hasNetworkFileErrors(networks: string[], files: FileValidationItem[]): boolean {
  return networks.some(network => getNetworkFileErrors(network, files).length > 0)
}
